import { Badge, Input } from "@";

const DrabbleConstantWords = ({
  isShow,
  constants,
  error,
  input,
  setValue,
}) => {
  // Drag and drop constant word to textarea
  const handleDragConstantWordStart = (constant) => {
    return (event) => {
      event.dataTransfer.setData("text", constant.id);
    };
  };

  // Drop constant word to textarea
  const handleDropToTextarea = (event) => {
    event.preventDefault();
    const draggedWord = event.dataTransfer.getData("text");
    if (draggedWord) {
      setValue("body", `${watch("body")} ${draggedWord}`.trim());
    }
  };

  return (
    <>
      <div className="mb-5">
        <label className="input-label">
          نص الرسالة
          {!isShow && <span className="star">*</span>}
        </label>

        {!isShow && (
          <>
            <p className="mb-2 text-xs text-gray-600 dark:text-gray-400">
              اسحب وأفلت لإضافة الثوابت داخل النص
            </p>
            <div className="mb-3 flex flex-wrap gap-3">
              {constants.map((constant) => (
                <Badge
                  draggable="true"
                  color="default"
                  className="cursor-move"
                  title={constant.name}
                  onDragStart={handleDragConstantWordStart(constant)}
                />
              ))}
            </div>
          </>
        )}
        <Input
          rows={7}
          error={error}
          input={input}
          type="textarea"
          disabled={isShow}
          onDrop={handleDropToTextarea}
          onDragOver={(e) => e.preventDefault()}
        />
      </div>
    </>
  );
};

export default DrabbleConstantWords;
